import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Avatar from "@mui/material/Avatar";

const PostCard = ({ index, post, imageOnly, handleClick = () => {}, ...rest }) => {
  const [isHover, setIsHover] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const account = useContext(AccountContext);
  const navigate = useNavigate();

  const primaryImage = post?.metadata?.coverImage;
  const owner = post?.owner || {};
  const ownerStore = owner?.stores?.[0];
  const fullName =
    owner.first_name || owner.last_name ? `${owner.first_name} ${owner.last_name}` : "";

  const handleDefaultDelete = async () => {
    if (!post?.id) {
      return toast.error("Could not find the post ID!");
    }
    try {
      await api.post.delete(post.id);
    } catch (err) {
      console.log(err);
      toast.error("Delete post failed!");
    }
  };

  return (
    <div>
      <SuiBox
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        sx={{
          borderRadius: 0,
          boxShadow: ({ boxShadows: { lg } }) => (isHover ? lg : "none"),
        }}
      >
        <SuiBox
          onClick={(e) => handleClick(e, post)}
          sx={{
            cursor: "pointer",
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.secondary.state, 0.1),
                rgba(gradients.secondary.state, 0.1)
              )}`,
            overflow: "hidden",
            position: "relative",
            display: "flex",
            minWidth: 0,
            width: "100%",
            ...rest?.sx,
          }}
          className="post-card-parent"
        >
          <ImageCardWrapper
            data={primaryImage}
            height={234}
            width={300}
            draggable={false}
            {...rest}
          />
          <SuiBox className="post-card-overlay">
            <SuiBox>
              <SuiTypography
                variant="body1"
                textTransform="none"
                color="white"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {post?.title}
              </SuiTypography>{" "}
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </SuiBox>
      {imageOnly ? null : (
        <SuiBox sx={{ my: 0.5 }}>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center">
            <SuiBox display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer" }}>
              <Avatar
                src={ownerStore?.metadata?.avatar}
                sx={{ width: 26, height: 26, cursor: "pointer" }}
                onClick={() =>
                  account?.id
                    ? navigate(`/wall/portfolio/${ownerStore.id}`)
                    : navigate(`/public/portfolio/${ownerStore.id}`)
                }
              />
              <SuiTypography
                variant="body2"
                color="dark"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-all",
                  cursor: "pointer",
                }}
                onClick={() =>
                  account?.id
                    ? navigate(`/wall/portfolio/${ownerStore.id}`)
                    : navigate(`/public/portfolio/${ownerStore.id}`)
                }
              >
                {/* {fullName ? fullName + `(${ownerStore.name})` : ownerStore.name} */}
                {ownerStore?.name}
              </SuiTypography>
            </SuiBox>
            <SuiBox display="flex" alignItems="center" gap={0.5}>
              <ThumbUpOutlinedIcon /> {post?.like_amount || 0}
              <VisibilityOutlinedIcon /> {post?.page_view || 0}
            </SuiBox>
          </SuiBox>
          <SuiBox display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer" }}>
            <SuiTypography
              variant="body2"
              textTransform="none"
              color="text"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              {owner?.name}
            </SuiTypography>{" "}
          </SuiBox>
        </SuiBox>
      )}
      {deleteVisible && post?.id ? (
        <Prompt
          heading="Delete Post"
          text={`Are you sure you want to delete: ${post.title}`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={() => handleDefaultDelete(post)}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}
    </div>
  );
};
export default PostCard;
